import React, { useEffect, useState } from 'react';
import { Button, Text, TextInput, View } from "../Components/Themed"
import type { BracketCompetitionProps, BracketCompetitionScoringRuleProps, BracketProps, CompanyProps, CompetitionPayoutTypeProps, CompetitionProps, CompetitionResultTypeProps, CompetitionTypeProps, CreateEngagementStepProps, EventProps, FocusPositionProps, GroupProps, LeagueProps, PollCampaignProps, PollProps, PublicPlayerProps, SquaresCompetitionProps } from '../types';
import { FlatList, Image, type ViewStyle } from 'react-native';
import { CreateEngagementApi, CreateEngagementHelpers } from './api';
import { Icons } from '../Components';
import { useColors } from '../constants/useColors';
import ImageUploader from '../Components/ImageUploader';
import moment from 'moment-mini';
import LeagueSchedule from '../MarketComponents/components/LeagueSchedule';
import { BracketCompetitionHelpers } from '../Bracket/api';

type CreateEngagementProps = {
    player?:PublicPlayerProps,
    onFocusPostiion?:(pos:FocusPositionProps) => void,
    onCreateCompetition:(competition:CompetitionProps) => void,
    onCreateBracketCompetition:(bc:BracketCompetitionProps) => void,
    onCreateSquaresCompetition:(sc:SquaresCompetitionProps) => void,
    onCreateFlashMarket:(fm:PollProps) => void,
    header_style?:ViewStyle,
    flash_campaign_id?:string,
    footer_style?:ViewStyle,
    bracket_id?:string,
    float?:boolean,
    onClose:() => void,
    init_engagement?:'competition'|'bracket'|'squares'|'flash'
    group_id?:string,
    company_id?:string
}

const sections = ['header','intro','step','info','groups','companies', 'create', 'image','success']

const steps:CreateEngagementStepProps[] = [
    { step_key: 'intro', num: 1, title: 'BettorEdge Engagements', description: 'Create an engagement and share with friends to play along' },
    { step_key: 'options', num:2, title: 'Engagement Types', description: 'Select an engagement type below to get started!' },
    { step_key: 'group', num:3, title: 'Add Group', description: 'Select one of your groups to add this engagement to!' },
    { step_key: 'company', num:4, title: 'Add Company', description: 'Select one of your companies to add this engagement to!' },
    { step_key: 'image', num:5, title:'Add an Image!', description: 'Add an image to your engagement to make it stand out!' },
    { step_key: 'create', num:6, title: 'Create Engagement', description: 'Complete the step below to create this BettorEdge Engagement!' },
    { step_key: 'success', num:7, title: 'Engagement Successfully Created!', description: 'Your engagement is in pending status. You can activate it when ready from your dashboard or the engagement screen!' }
]

const CreateEngagement = ({ float, player, bracket_id, flash_campaign_id, init_engagement, onFocusPostiion, group_id, company_id, header_style, footer_style, onClose, onCreateCompetition, onCreateBracketCompetition, onCreateSquaresCompetition, onCreateFlashMarket}:CreateEngagementProps) => {
    const Colors = useColors();
    const [ size, setSize ] = useState({ width:0, height:0 });
    const [ draft_squares, setDraftSquares ] = useState<SquaresCompetitionProps | undefined>(undefined);
    const [ draft_bracket_competition, setDraftBracketCompetition ] = useState<BracketCompetitionProps | undefined>(undefined);
    const [ pending_engagement, setPendingEngagement ] = useState<{
        create_loading:boolean,
        competition?:CompetitionProps,
        poll?:PollProps,
        bracket_competition?:BracketCompetitionProps,
        squares_competition?:SquaresCompetitionProps
    }>({
        create_loading: false
    });
    const [ draft_flash, setDraftFlash ] = useState<PollProps | undefined>(undefined);
    const [ draft_competition, setDraftCompetition ] = useState<undefined | {
        loading:boolean,
        types_visible:boolean,
        results_visible: boolean,
        competition_name:string,
        competition_template_id?:string,
        competition_type?:CompetitionTypeProps,
        pacer_id?:string,
        competition_result_type?:CompetitionResultTypeProps,
        competition_description:string,
        competition_types:CompetitionTypeProps[],
        competition_payout_types:CompetitionPayoutTypeProps[],
        competition_result_types:CompetitionResultTypeProps[]
    }>(undefined);

    const [ draft_image, setDraftImage ] = useState<any>(undefined);
    const [ active_step, setActiveStep ] = useState<CreateEngagementStepProps>(steps[0] as CreateEngagementStepProps)
    const [ state, setState ] = useState<{
        loading: boolean,
        active_engagment?:'competition'|'squares'|'flash'|'bracket',
        active_group?:GroupProps,
        active_company?:CompanyProps,
        groups:GroupProps[],
        companies:CompanyProps[]
    }>({
        loading:false,
        groups: [],
        companies: []
    });

    const { active_engagment, groups, companies, active_company, active_group } = state;

    useEffect(() => {
        CreateEngagementApi.setEnvironment();
        loadStaticData();
    },[player?.player_id])

    const loadStaticData = async() => {
        setState({ ...state, loading:true });
        let my_grups = await CreateEngagementApi.getMyGroups(0);
        let my_comps = await CreateEngagementApi.getMyCompanies();
        let act_group = my_grups.groups.find(g => g.group_id == group_id);
        let act_company = my_comps.companies.find(c => c.company_id == company_id);
        setState({
            ...state,
            active_group: act_group,
            active_engagment: init_engagement ? init_engagement : active_engagment,
            active_company: act_company,
            groups: my_grups.groups,
            companies: my_comps.companies,
            loading:false
        });
        if(act_company?.company_image?.url){
            setDraftImage(act_company.company_image)
        }
    }
    const errors = CreateEngagementHelpers.isStepValid(active_step, active_engagment, draft_competition, draft_squares, draft_flash, draft_bracket_competition);

    const handleNextStep = async() => {
        if(errors.length > 0){ return alert(errors.map(e => e)) }
        let next_step = steps[active_step.num]
        //if(!next_step){ return }
        switch(active_step.step_key){
            case 'intro':
                if(!next_step){ return }
                return setActiveStep(next_step)
            case 'options':
                let group_step = steps.find(s => s.step_key == 'group');
                let company_step = steps.find(s => s.step_key == 'company');
                let create_step = steps.find(s => s.step_key == 'create');
                if(group_step && groups.length > 0){ return setActiveStep(group_step) }
                if(company_step && companies.length > 0){ return setActiveStep(company_step) }
                if(!create_step){ return }
                return setActiveStep(create_step)
            case 'group':
                let n_company_step = steps.find(s => s.step_key == 'company');
                let n_create_step = steps.find(s => s.step_key == 'create');
                if(n_company_step && companies.length > 0){ return setActiveStep(n_company_step) }
                if(!n_create_step){ return }
                return setActiveStep(n_create_step)
            case 'company':
                if(!next_step){ return }
                return setActiveStep(next_step)
            case 'image':
                if(!next_step){ return }
                return setActiveStep(next_step)
            case 'create':
                switch(active_engagment){
                    case 'competition':
                        if(!draft_competition){ return }
                        if(errors.length > 0){ return alert(errors.map(e => e)) }
                        if(!draft_competition.competition_type){ return }
                        if(!draft_competition.competition_result_type){ return }
                        setPendingEngagement({ ...pending_engagement, create_loading: true });
                        
                        let new_competition = await CreateEngagementApi.createCompetition(
                            draft_competition.competition_name, 
                            draft_competition.competition_description, 
                            draft_competition.competition_type.competition_type_id,
                            draft_competition.competition_result_type.competition_result_type_id,
                            active_company?.company_id,
                            active_group?.group_id,
                            draft_competition.pacer_id,
                            draft_competition.competition_template_id,
                            undefined,
                            draft_image
                        )
                        
                        setPendingEngagement({ ...pending_engagement, create_loading: false, competition: new_competition });
                        break
                    case 'squares':
                        if(!draft_squares){ return alert('Unable to process') }
                        if(errors.length > 0){ return alert(errors.map(e => e)) }
                        setPendingEngagement({ ...pending_engagement, create_loading:true })
                        const new_squares_comp = await CreateEngagementApi.createSquaresCompetition({ ...draft_squares, image: draft_image, company_id: active_company?.company_id, group_id: active_group?.group_id});
                        setPendingEngagement({ ...pending_engagement, create_loading: false, squares_competition: new_squares_comp });
                        break
                    case 'flash':
                        if(!draft_flash){ return alert('Unable to process') }
                        if(errors.length > 0){ return alert(errors.map(e => e)) }
                        setPendingEngagement({ ...pending_engagement, create_loading: true });
                        const new_flash_market = await CreateEngagementApi.createPoll({ ...draft_flash, poll_image: draft_image });
                        if(!new_flash_market){ return alert('Unable to process') }
                        setPendingEngagement({ ...pending_engagement, create_loading: false, poll: new_flash_market });
                        break
                    case 'bracket':
                        if(!draft_bracket_competition){ return alert('Unable to process') }
                        if(errors.length > 0){ return alert(errors.map(e => e)) }
                        setPendingEngagement({ ...pending_engagement, create_loading: true });
                        const bracket_resp = await CreateEngagementApi.getBracketById(draft_bracket_competition.bracket_id);
                        if(!bracket_resp){ return alert('Unable to process.  Please try again later') }
                        const scoring = BracketCompetitionHelpers.getDefaultScoringRules('', bracket_resp.bracket_rounds);
                        const comp_response = await CreateEngagementApi.createBracketCompetition({ ...draft_bracket_competition, image: draft_image, company_id: active_company?.company_id, group_id: active_group?.group_id }, scoring);
                        if(!comp_response){ return alert('Unable to process') }
                        setPendingEngagement({ ...pending_engagement, create_loading: false, bracket_competition:comp_response.bracket_competition });
                        break
                    default: return //We cdont have one!
                }
                if(next_step){ setActiveStep(next_step)}
                return
            case 'success':
                switch(active_engagment){
                    case 'competition':
                        if(!pending_engagement.competition){ return alert('Unable to process') }
                        return onCreateCompetition(pending_engagement.competition)
                    case 'bracket':
                        if(!pending_engagement.bracket_competition){ return alert('Unable to process') }
                        return onCreateBracketCompetition(pending_engagement.bracket_competition)
                    case 'squares':
                        if(!pending_engagement.squares_competition){ return alert('Unable to process') }
                        return onCreateSquaresCompetition(pending_engagement.squares_competition)
                    case 'flash':
                        if(!pending_engagement.poll){ return alert('Unable to process') }
                        return onCreateFlashMarket(pending_engagement.poll);
                    default: return alert('Unable to process')
                }
            default: return
        }
    }

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'intro':
                if(active_step.step_key != 'intro'){ return <></> }
                return (
                    <View>
                        <Image
                            source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1757428505/ChatGPT_Image_Sep_9_2025_09_34_28_AM_vzjage.png' }}
                            style={{ width: size.width, height: size.width * 0.5 }}
                            resizeMode='cover'
                        />
                    </View>
                )
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, ...header_style }}>
                        {draft_image?.url ?
                        <Image
                            source={{ uri: draft_image?.url }}
                            style={{ height:50, width:50 }}
                            resizeMode='cover'
                        />
                        : active_engagment == 'competition' ?
                        <Icons.PickEmIcon size={20} color={Colors.text.h1} />
                        : active_engagment == 'bracket' ?
                        <Icons.BracketIcon size={20} color={Colors.text.h1} />
                        : active_engagment == 'squares' ?
                        <Icons.SquaresIcon size={20} color={Colors.text.h1} />
                        : <></>}
                        <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                            <Text theme='h1'>Create {active_engagment ? active_engagment : 'Engagement'}</Text>
                            <Text theme='description'>Follow the steps below to create your engagement</Text>
                        </View>
                        <Button
                            title='X'
                            float
                            title_color={Colors.text.error}
                            onPress={() => onClose()}
                        />
                    </View>
                )
            case 'step':
                return (
                    <View style={{ padding:20 }}>
                        <Text theme='h1' size={38}>{active_step.title}</Text>
                        <Text theme='description' color={errors.length > 0 ? Colors.text.warning :Colors.text.success} size={16} style={{ marginTop:10 }}>{active_step.description}</Text>
                    </View>
                )
            case 'info':
                switch(active_step.step_key){
                    case 'intro':
                        return <IntroInfo />
                    case 'options':
                        return (
                            <View style={{ padding:10 }}>
                                <EngagementOptions companies={companies} groups={groups} active_engagement={active_engagment} onSelectEngagement={(e) => {
                                    if(e == active_engagment){ return setState({ ...state, active_engagment: undefined }) }
                                    return setState({ ...state, active_engagment: e })
                                }}
                                />
                            </View>
                        )
                    default: return <></>
                }
            case 'success':
                if(active_step.step_key != 'success'){ return <></> }
                return (
                    <View>
                        <Image
                            source={{ uri: draft_image?.url }}
                            style={{ width: size.width, height: size.width }}
                            resizeMode='contain'
                        />
                    </View>
                )
            case 'image':
                if(active_step.step_key != 'image'){ return <></> }
                return (
                    <View style={{ justifyContent:'center', alignItems:'center' }}>
                        <ImageUploader 
                            public_id={`${(Math.random() * 10000000).toFixed()}_${active_engagment}_pic`}
                            onFinishUpload={(obj) => setDraftImage({ ...obj, url: obj.secure_url })}
                            >
                            {draft_image ?
                            <Image
                                source={{ uri: draft_image.url }}
                                style={{ width: size.width, height: size.width }}
                                resizeMode='cover'
                            />
                            :
                            <Icons.ImageIcon size={150} color={Colors.text.h1} />
                            }
                            <Text textAlign='center' style={{ marginTop:15 }} theme='h1' color={Colors.text.action}>{draft_image ? 'CHANGE IMAGE' : "ADD AN IMAGE"}</Text>
                        </ImageUploader>
                    </View>
                )
            case 'groups':
                if(active_step.step_key != 'group'){ return <></> }
                return (
                    <View transparent style={{ margin:20 }}>
                    <GroupSelector
                        groups={groups}
                        active_group={active_group}
                        onSelectGroup={(g) => setState({ ...state, active_group: g })}
                    />
                    </View>
                )
            case 'companies':
                if(active_step.step_key != 'company'){ return <></> }
                return (
                    <View transparent style={{ margin:20 }}>
                    <CompanySelector 
                        companies={companies}
                        active_company={active_company}
                        onSelectCompany={(c) => setState({ ...state, active_company: c })}
                    />
                    </View>
                )
            case 'create':
                if(active_step.step_key != 'create'){ return <></> }
                if(!player){ return <></> }
                switch(active_engagment){
                    case 'competition':
                        return <CreateCompetition onUpdateDraft={(d) => setDraftCompetition(d)} onFocusPosition={onFocusPostiion} />
                    case 'squares':
                        return <CreateSquares onUpdateDraft={(d) => setDraftSquares(d)} onFocusPosition={onFocusPostiion}/>
                    case 'flash':
                        return <CreateFlashMarket group={active_group} flash_campaign_id={flash_campaign_id} onUpdateDraft={(d) => setDraftFlash(d)} onFocusPosition={onFocusPostiion} company={active_company}/>
                    case 'bracket':
                        return <CreateBracketCompetition group={active_group} bracket_id={bracket_id} onUpdateDraft={(d) => setDraftBracketCompetition(d)} onFocusPosition={onFocusPostiion} company={active_company}/>
                    default: return <></>
                }
            default: return <></>
        }
    }

    return (
        <View float={float} style={{flex:1}} onLayout={(ev) => {
            const { height, width } = ev.nativeEvent.layout;
            setSize({ height, width });
        }}>
            <View transparent style={{ flex:1 }}>
                <FlatList
                    data={sections}
                    key={'create_engagement_list'}
                    keyExtractor={item => item}
                    renderItem={renderSections}
                />
            </View>
            {active_step.step_key == 'intro' ?
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, ...footer_style }}>
                <Button
                    style={{ flex:1 }}
                    title='GET STARTED'
                    type='success'
                    onPress={() => handleNextStep()}
                />
            </View>
            : active_step.step_key == 'success' ?
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, ...footer_style }}>
                <Button
                    style={{ flex:1 }}
                    title='GO TO YOUR ENGAGEMENT'
                    type='success'
                    onPress={() => handleNextStep()}
                />
            </View>
            :
             <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <Button float style={{ height:50, width:50, padding:0, justifyContent:'center', alignItems:'center', borderRadius:100 }}
                    onPress={() => {
                        let prev_step = steps.find(s => s.num == active_step.num - 1)
                        if(prev_step?.step_key == 'group' && groups.length == 0){
                            prev_step = steps.find(s => s.step_key == 'options')
                        }
                        if(prev_step?.step_key == 'company' && companies.length == 0){
                            prev_step = steps.find(s => s.step_key == 'options')
                        }
                        if(!prev_step){ return alert('Unable to do it') }
                        setActiveStep(prev_step)
                    }}
                >
                    <Icons.ChevronIcon direction='left' size={14} color={Colors.text.h1} />
                </Button>
                <View style={{ flex:1 }} />
                <Button 
                    float
                    disabled={pending_engagement.create_loading ? true : false}
                    loading={pending_engagement.create_loading}
                    style={{ padding: active_step.step_key == 'create' ? 10 : 0, height:active_step.step_key == 'create' ? undefined : 50, width:active_step.step_key == 'create' ? undefined : 50, justifyContent:'center', alignItems:'center', borderRadius:100, opacity: errors.length == 0 && !pending_engagement.create_loading ? 1:0.5 }}
                    onPress={() => handleNextStep()}>
                    {active_step.step_key == 'create' ?
                    <Text theme='h1' color={errors.length > 0 ? Colors.text.warning : Colors.text.success}>CREATE</Text>
                    :
                    <Icons.ChevronIcon direction='right' size={14} color={errors.length == 0 ? Colors.text.success : Colors.text.h1} />
                    }
                </Button>
            </View>
            }
        </View>
    )
}

export default CreateEngagement


const IntroInfo = () => {
    return (
        <View style={{ padding:20 }}>
            <Text theme='h1'>🎮 Make It Yours – Create custom pick-ems, competitions, or games in just a few steps</Text>
            <Text theme='h1' style={{ marginTop:20 }}>👥 Play With Friends – Invite your group or the whole BettorEdge community</Text>
            <Text theme='h1' style={{ marginTop:20 }}>📊 Track & Compete – See results, leaderboards, and bragging rights update in real time</Text>
        </View>
    )
}
type CreateBracketCompetitionProps = {
    company?:CompanyProps,
    group?:GroupProps,
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onUpdateDraft: (poll:BracketCompetitionProps) => void,
    bracket_id?:string
}
const CreateBracketCompetition = ({ bracket_id, company, group, onFocusPosition, onUpdateDraft }:CreateBracketCompetitionProps) => {
    const Colors = useColors();
    const [ create_state, setCreateState ] = useState<{
        brackets:BracketProps[],
        leagues:LeagueProps[],
        loading:boolean,
        results_visible:boolean,
        competition_result_types:CompetitionResultTypeProps[],
        draft_bracket_competition:BracketCompetitionProps,
        scoring:BracketCompetitionScoringRuleProps[]
    }>({
        brackets:[],
        leagues: [],
        results_visible: false,
        competition_result_types:[],
        scoring:[],
        loading: false,
        draft_bracket_competition: { ...CreateEngagementHelpers.generateBracketCompetition(), bracket_id:bracket_id??'', group_id:group?.group_id, company_id:company?.company_id }
    });
    const { brackets, leagues, results_visible, draft_bracket_competition, competition_result_types } = create_state;
    const active_bracket = brackets.find(b => b.bracket_id == draft_bracket_competition.bracket_id);
    const competition_result_type = competition_result_types.find(rt => rt.competition_result_type_id == draft_bracket_competition.competition_result_type_id);
    
    useEffect(() => {
        getData()
    },[]);

    useEffect(() => {
        onUpdateDraft(draft_bracket_competition);
    },[JSON.stringify(draft_bracket_competition)]);


    const getData = async() => {
        setCreateState({ ...create_state, loading: true });
        const s_leagues = await CreateEngagementApi.getLeagues();
        const s_brackets = await CreateEngagementApi.getActiveBrackets();
        let options = await CreateEngagementApi.getCompetitionOptions();
        setCreateState({
            ...create_state,
            brackets: s_brackets,
            competition_result_types: options.competition_result_types,
            leagues: s_leagues,
            loading:false
        })
    }

    const renderResultTypes = (data:{item:CompetitionResultTypeProps, index:number}) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', borderRadius:0, padding:10, alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setCreateState({ ...create_state, results_visible: false, draft_bracket_competition: { ...draft_bracket_competition, competition_result_type_id: data.item.competition_result_type_id } })}
            >
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{data.item.label}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Name</Text>
                <TextInput
                    placeholder='Add Name here...'
                    value={draft_bracket_competition.competition_name}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:draft_bracket_competition.competition_name ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setCreateState({ ...create_state, draft_bracket_competition: { ...draft_bracket_competition, competition_name: text } })}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Description</Text>
                <TextInput
                    placeholder='Add Description here...'
                    value={draft_bracket_competition.competition_description}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:draft_bracket_competition.competition_description ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setCreateState({ ...create_state, draft_bracket_competition: { ...draft_bracket_competition, competition_description: text } })}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Select a Bracket</Text>
                <BracketSelector
                    leagues={leagues}
                    brackets={brackets.filter(b => moment().isBefore(moment(b.scheduled_datetime)))}
                    active_bracket={active_bracket}
                    onSelectBracket={(bracket) => {
                        setCreateState({ ...create_state, draft_bracket_competition: { ...draft_bracket_competition, bracket_id: bracket?.bracket_id ?? '', scheduled_datetime: bracket?.scheduled_datetime } })
                    }}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Payout Type</Text>
                <Button float style={{ borderColor:competition_result_type ? Colors.text.success: Colors.text.warning }} onPress={() => setCreateState({ ...create_state, results_visible: !results_visible })}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{competition_result_type?.label ?? 'Select Payout'}</Text>
                        <Icons.ChevronIcon direction={results_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {results_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={competition_result_types.sort((a,b) => a.label.localeCompare(b.label))}
                        key={'competition_reult_types'}
                        keyExtractor={item => item.competition_result_type_id.toString()}
                        renderItem={renderResultTypes}
                    />
                    </View>
                    :<></>}
                </Button>
            </View>
        </View>
    )

}

type CreateFlashMarketProps = {
    company?:CompanyProps,
    group?:GroupProps,
    flash_campaign_id?:string,
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onUpdateDraft: (poll:PollProps) => void
}

const CreateFlashMarket = ({ company, group, flash_campaign_id, onFocusPosition, onUpdateDraft }:CreateFlashMarketProps) => {
    //Get active campaigns
    const Colors = useColors();
    const [ create_state, setCreateState ] = useState<{
        draft_poll: PollProps,
        campaign_loading:boolean,
        new_campaign?:boolean,
        draft_campaign:PollCampaignProps,
        campaigns_visible:boolean,
        poll_campaigns:PollCampaignProps[]
    }>({
        draft_poll: { ...CreateEngagementHelpers.generateFlashMarket(), poll_campaign_id : flash_campaign_id ?? ''},
        campaigns_visible: false,
        new_campaign: false,
        campaign_loading:false,
        draft_campaign: CreateEngagementHelpers.generateEmptyFlashCampaign(),
        poll_campaigns: []
    });
    const { draft_poll, campaigns_visible, campaign_loading, draft_campaign, poll_campaigns, new_campaign } = create_state;
    const active_campaign = poll_campaigns.find(pc => pc.poll_campaign_id == draft_poll.poll_campaign_id);
    useEffect(() => {
        getData();
    },[company?.company_id, group?.group_id]);

    useEffect(() => {
        onUpdateDraft(draft_poll);
    },[JSON.stringify(draft_poll)]);

    const getData = async() => {
        let pc = await CreateEngagementApi.getMyAdminFlashCampaigns();
        if(company){
            pc = await CreateEngagementApi.getCompanyActiveFlashCampaigns(company.company_id)
        }
        if(group){
            pc = pc.filter(c => c.group_id == group.group_id)
        }
        setCreateState({
            ...create_state,
            poll_campaigns: pc.filter(pc => pc.market_type == 'FOR_MONEY')
        })
    }

    const renderCampaigns = (data:{ item:PollCampaignProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setCreateState({ ...create_state, campaigns_visible:false, draft_poll: { ...draft_poll, poll_campaign_id: data.item.poll_campaign_id } })}
            >
                <Image
                    source={{ uri: data.item.campaign_image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:10 }}>
            <View style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <View transparent style={{ flexDirection:'row', alignItems:'center', marginBottom:10 }}>
                    <View transparent style={{ flex:1 }}>
                        <Text theme='h1'>Select Campaign</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Group your flash markets into like campaigns to better manage them</Text>
                        <Button
                            title={!new_campaign?'Create a new campaign' : 'Select Existing Campaign'}
                            title_color={ new_campaign?Colors.text.action:Colors.text.success }
                            transparent
                            style={{ alignItems:'flex-start', padding:10, paddingLeft:0 }}
                            onPress={() => setCreateState({ ...create_state, new_campaign: !new_campaign })}
                        />
                    </View>
                </View>
                {!new_campaign ?
                <Button float onPress={() => setCreateState({ ...create_state, campaigns_visible:!campaigns_visible }) }>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_campaign?.name ?? 'No Campaign'}</Text>
                        <Icons.ChevronIcon direction={campaigns_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {campaigns_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={poll_campaigns}
                        key={'campaign_selector'}
                        keyExtractor={item => item.poll_campaign_id.toString()}
                        renderItem={renderCampaigns}
                    />
                    </View>
                    :<></>}
                </Button>
                :
                <View>
                    <View transparent style={{ marginBottom:10 }}>
                        <Text theme='h1'>Campaign Name</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Enter the campaign name here. Use a name that appropriately groups the flash markets</Text>
                    </View>
                    <TextInput
                        placeholder='Add Campaign Name here...'
                        value={draft_campaign.name}
                        onFocusPosition={onFocusPosition}
                        style={{ borderColor:draft_campaign.name ? Colors.text.success : Colors.text.warning }}
                        onChangeText={(text) => setCreateState({ ...create_state, draft_campaign: { ...draft_campaign, name: text } })}
                    />
                    <Button
                        title='CREATE CAMPAIGN'
                        loading={campaign_loading}
                        type='success'
                        disabled={!draft_campaign.name ? true : false}
                        style={{ opacity: campaign_loading || !draft_campaign.name ? 0.5: 1, marginTop:10 }}
                        onPress={async() => {
                            if(campaign_loading){ return }
                            if(!draft_campaign.name){ return }
                            //Create the new campaign!
                            setCreateState({ ...create_state, campaign_loading:true });
                            const new_pc = await CreateEngagementApi.createPollCampaign({ ...draft_campaign, group_id: group?.group_id, company_id: company?.company_id, campaign_image: company?.company_image })
                            if(!new_pc){ 
                                alert('Unable to create a campaign at this time');
                                setCreateState({ ...create_state, campaign_loading: false });
                                return
                            }
                            setCreateState({
                                ...create_state,
                                campaign_loading: false,
                                new_campaign: false,
                                draft_poll: { ...draft_poll, poll_campaign_id: new_pc.poll_campaign_id },
                                poll_campaigns: poll_campaigns.concat(new_pc)
                            });
                        }}
                    />
                </View>
                }
                {group && !new_campaign ?
                <Text theme='warning' style={{ marginTop:5 }}>Only showing campaigns associated with the {group.name} group. If you need a different campaign - go back and unselect this group.</Text>
                :<></>}
            </View>
            <View style={{ padding:10 }}>
                <View transparent style={{ marginBottom:10 }}>
                    <Text theme='h1'>Question Name</Text>
                    <Text theme='description' style={{ marginTop:4 }}>Enter the question here.  You can modify it up until you activate it.</Text>
                </View>
                <TextInput
                    placeholder='Add Question here...'
                    value={draft_poll.poll_question}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:draft_poll.poll_question ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setCreateState({ ...create_state, draft_poll: { ...draft_poll, poll_question: text } })}
                />
            </View>
        </View>
    )
}

type EngagementOptionProps = {
    companies:CompanyProps[],
    groups:GroupProps[],
    active_engagement?: 'competition'|'squares'|'flash'|'bracket',
    onSelectEngagement: (engagement:'competition'|'squares'|'flash'|'bracket') => void
}
const EngagementOptions = ({active_engagement, companies, onSelectEngagement}:EngagementOptionProps) => {
    const Colors = useColors();
    return (
        <View>
            <Button
                key='competition'
                float
                style={{ padding:10, margin:10, flexDirection:'row', alignItems:'center', borderColor:active_engagement == 'competition' ? Colors.text.success: Colors.borders.light }}
                onPress={() => onSelectEngagement('competition')}
            >
                <Icons.PickEmIcon size={50} color={active_engagement == 'competition' ? Colors.text.success :Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1' color={active_engagement == 'competition' ? Colors.text.success : Colors.text.h1}>BettorEdge Competition</Text>
                    <Text theme='description' color={active_engagement == 'competition' ? Colors.text.success : Colors.text.h1} style={{ marginTop:4 }}>Create a pick-em or wager based competition.  Players will pick or wager multiple outcomes.  Get more right and climb the leaderboard for large payouts</Text>
                </View>
            </Button>
            <Button
                key='squares'
                float
                style={{ padding:10, margin:10, flexDirection:'row', alignItems:'center', borderColor:active_engagement == 'squares' ? Colors.text.success: Colors.borders.light }}
                onPress={() => onSelectEngagement('squares')}
            >
                <Icons.SquaresIcon size={50} color={active_engagement == 'squares' ? Colors.text.success :Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1' color={active_engagement == 'squares' ? Colors.text.success : Colors.text.h1}>Auction Squares</Text>
                    <Text theme='description' color={active_engagement == 'squares' ? Colors.text.success : Colors.text.h1} style={{ marginTop:4 }}>Create an auction squares game.  Bid on squares until the auction ends.  Buy and sell squares throughout the game.</Text>
                </View>
            </Button>
            <Button
                key='bracket'
                float
                style={{ padding:10, margin:10, flexDirection:'row', alignItems:'center', borderColor:active_engagement == 'bracket' ? Colors.text.success: Colors.borders.light }}
                onPress={() => onSelectEngagement('bracket')}
            >
                <Icons.BracketIcon size={50} color={active_engagement == 'bracket' ? Colors.text.success :Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1' color={active_engagement == 'bracket' ? Colors.text.success : Colors.text.h1}>Bracket Challenge</Text>
                    <Text theme='description' color={active_engagement == 'bracket' ? Colors.text.success : Colors.text.h1} style={{ marginTop:4 }}>Create a bracket.  Make picks until the championship. Pick more correctly and win!</Text>
                </View>
            </Button>
            {companies.length > 0 ?
            <Button
                key='flash'
                float
                style={{ padding:10, margin:10, flexDirection:'row', alignItems:'center', borderColor:active_engagement == 'flash' ? Colors.text.success: Colors.borders.light }}
                onPress={() => onSelectEngagement('flash')}
            >
                <Icons.FlameIcon size={50} color={active_engagement == 'flash' ? Colors.text.success :Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1' color={active_engagement == 'flash' ? Colors.text.success : Colors.text.h1}>Custom Market</Text>
                    <Text theme='description' color={active_engagement == 'flash' ? Colors.text.success : Colors.text.h1} style={{ marginTop:4 }}>Create a custom flash market.  Players bet on the perimutuel outcomes, get it right and get paid!</Text>
                </View>
            </Button>
            :<></>}
        </View>
    )
}



type BracketSelectorProps = {
    active_bracket?:BracketProps,
    brackets:BracketProps[],
    leagues:LeagueProps[],
    onSelectBracket:(bracket?:BracketProps) => void
}
const BracketSelector = ({ active_bracket, brackets, leagues, onSelectBracket }:BracketSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const renderBrackets = (data:{ item:BracketProps, index:number }) => {
        const league = leagues.find(l => l.league_id == data.item.league_id);
        if(!league){ return <></> }
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectBracket(data.item) }}
            >
                <Image
                    source={{ uri: league.league_image }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.bracket_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Begins {moment(data.item.scheduled_datetime).format('MMM DD hh:mm a')}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Button float style={{ borderColor:active_bracket ? Colors.text.success : Colors.text.warning }} onPress={() => { setVisible(!visible); onSelectBracket(undefined)}}>
            <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_bracket?.bracket_name ?? 'No Bracket'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </View>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={brackets.sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())}
                key={'bracket_selector'}
                keyExtractor={item => item.bracket_id.toString()}
                renderItem={renderBrackets}
            />
            </View>
            :<></>}
        </Button>
    )
}



type GroupSelectorProps = {
    active_group?:GroupProps,
    groups:GroupProps[],
    onSelectGroup:(group?:GroupProps) => void
}
export const GroupSelector = ({ active_group, groups, onSelectGroup }:GroupSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const renderGroups = (data:{ item:GroupProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectGroup(data.item) }}
            >
                <Image
                    source={{ uri: data.item.group_image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Button float onPress={() => { setVisible(!visible); onSelectGroup(undefined)}}>
            <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_group?.name ?? 'No Group'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </View>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={groups}
                key={'group_selector'}
                keyExtractor={item => item.group_id.toString()}
                renderItem={renderGroups}
            />
            </View>
            :<></>}
        </Button>
    )
}





type CompanySelectorProps = {
    active_company?:CompanyProps,
    companies:CompanyProps[],
    onSelectCompany:(c?:CompanyProps) => void
}
export const CompanySelector = ({ active_company, companies, onSelectCompany }:CompanySelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const renderCompanies = (data:{ item:CompanyProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectCompany(data.item) }}
            >
                <Image
                    source={{ uri: data.item.company_image?.url }}
                    style={{ height:40, width:40 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.company_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.company_description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Button float onPress={() => { setVisible(!visible); onSelectCompany(undefined) }}>
            <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_company?.company_name ?? 'No Company'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </View>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={companies}
                key={'company_selector'}
                keyExtractor={item => item.company_id.toString()}
                renderItem={renderCompanies}
            />
            </View>
            :<></>}
        </Button>
    )
}


type SCProps = {
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onUpdateDraft:(draft_sq_comp:SquaresCompetitionProps) => void
}

const CreateSquares = ({onFocusPosition, onUpdateDraft}:SCProps) => {
    const Colors = useColors();
    const [ draft, setDraft ] = useState<SquaresCompetitionProps>(CreateEngagementHelpers.generateSquaresComp());
    const [ sq_data, setSQData ] = useState<{
        leagues:LeagueProps[],
        leagues_visible:boolean,
        active_league?:LeagueProps,
        league_schedule:boolean,
        active_event?:EventProps,
    }>({
        leagues:[],
        leagues_visible:false,
        league_schedule: false
    });
    const { leagues, leagues_visible, league_schedule, active_league, active_event } = sq_data;

    useEffect(() => {
        getData()
    },[]);

    const getData = async() => {
        const lgs = await CreateEngagementApi.getLeagues();
        setSQData({ ...sq_data, leagues: lgs.filter(l => l.sport.toLowerCase() == 'football') });
    }

    useEffect(() => {
        onUpdateDraft(draft);
    },[JSON.stringify(draft)])

    const renderLeagues = (data:{item:LeagueProps, index:number}) => {
        const selected = active_league?.league_id == data.item.league_id ? true : false
       
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', borderRadius:0, padding:10, alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setSQData({ ...sq_data, active_league: selected?undefined : data.item, leagues_visible:false, league_schedule: selected?false:true })}
            >
                <Image
                    source={{ uri: data.item.league_image }}
                    style={{ height:30, width:30 }}
                    resizeMode='contain'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.league_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.sport}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Name</Text>
                <TextInput
                    placeholder='Add Name here...'
                    value={draft.sq_comp_name}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:draft.sq_comp_name ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setDraft({ ...draft, sq_comp_name: text })}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Description</Text>
                <TextInput
                    placeholder='Add Decription here...'
                    onFocusPosition={onFocusPosition}
                    value={draft.sq_comp_description}
                    style={{ borderColor:draft.sq_comp_description ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setDraft({ ...draft, sq_comp_description: text })}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Squares Event</Text>
                <Button float style={{ borderColor:active_league?Colors.text.success:Colors.text.warning }} onPress={() => setSQData({ ...sq_data, leagues_visible: !leagues_visible })}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_league?.league_name ?? 'Select League'}</Text>
                        <Icons.ChevronIcon direction={leagues_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {leagues_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={leagues.sort((a,b) => a.priority - b.priority)}
                        key={'competition_reult_types'}
                        keyExtractor={item => item.league_id.toString()}
                        renderItem={renderLeagues}
                    />
                    </View>
                    :<></>}
                </Button>
            </View>
            <View float style={{ margin:10 }}>
                {active_league && league_schedule ?
                <LeagueSchedule
                    onSelectEvent={(e) => {
                        setSQData({ ...sq_data, active_event: e, league_schedule:false });
                        setDraft({ ...draft, sport: active_league?.league_name, begin_datetime: moment(e.scheduled_datetime).add(4, 'minutes'), event_id: e.event_id })
                    }}
                    league={active_league}
                    active_event={active_event?.event_id}
                />
                : active_event ?
                <Button style={{ borderColor:active_event?Colors.text.success:Colors.text.warning }} float onPress={() => setSQData({ ...sq_data, league_schedule: true })}>
                    <Text theme='h1'>{active_event.event_title}</Text>
                </Button> 
                :<></>}
            </View>
        </View>
    )
}

type CCProps = {
    onFocusPosition?:(pos:FocusPositionProps) => void,
    onUpdateDraft:(draft: {
        loading:boolean,
        types_visible:boolean,
        results_visible: boolean,
        competition_name:string,
        competition_type?:CompetitionTypeProps,
        competition_result_type?:CompetitionResultTypeProps,
        competition_description:string,
        competition_types:CompetitionTypeProps[],
        competition_payout_types:CompetitionPayoutTypeProps[],
        competition_result_types:CompetitionResultTypeProps[]
    }) => void
}

const CreateCompetition = ({ onFocusPosition, onUpdateDraft }:CCProps) => {
    const Colors = useColors();
    const [ templates, setTemplates ] = useState<CompetitionProps[]>([]);
    const [ draft, setDraft ] = useState<{
        loading:boolean,
        templates_visible:boolean,
        types_visible:boolean,
        results_visible: boolean,
        pacer_id?:string,
        competition_template_id?:string,
        competition_name:string,
        competition_type?:CompetitionTypeProps,
        competition_result_type?:CompetitionResultTypeProps,
        competition_description:string,
        competition_types:CompetitionTypeProps[],
        competition_payout_types:CompetitionPayoutTypeProps[],
        competition_result_types:CompetitionResultTypeProps[]
    }>({
        loading: false, templates_visible:false, types_visible:false, results_visible: false, competition_description:'', competition_name:'', competition_payout_types:[], competition_result_types:[], competition_types:[]
    });
    const { competition_name, competition_template_id, templates_visible, competition_description,competition_result_types, types_visible, competition_types, results_visible, competition_type, competition_result_type } = draft;
    const template = templates.find(t => t.competition_id == competition_template_id)
    useEffect(() => {
        CreateEngagementApi.setEnvironment();
        getData();
    },[]);

    useEffect(() => {
        onUpdateDraft(draft)
    },[JSON.stringify(draft)])

    const getData = async() => {
        setDraft({ ...draft, loading:true });
        let options = await CreateEngagementApi.getCompetitionOptions();
        let temps = await CreateEngagementApi.getTemplateCompetitions();
        setDraft({
            ...draft,
            loading: false,
            competition_result_types: options.competition_result_types,
            competition_types: options.competition_types,
            competition_payout_types:options.competition_payout_types,
        });
        setTemplates(temps)
    }

    const renderCompetitionTypes = (data:{item:CompetitionTypeProps, index:number}) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', borderRadius:0, padding:10, alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setDraft({ ...draft, competition_type: data.item, types_visible: false })}
            >
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{data.item.type_label}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    const renderTemplates = (data:{item:CompetitionProps, index:number}) => {
        const selected = competition_template_id == data.item.competition_id ? true : false
        const comp_type = competition_types.find(ct => ct.competition_type_id == data.item.competition_type_id)
        const comp_result = competition_result_types.find(crt => crt.competition_result_type_id == data.item.competition_result_type_id);
        if(!comp_type || !comp_result){ return <></> }
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', borderRadius:0, padding:10, alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setDraft({ ...draft, competition_template_id: selected ? undefined : data.item.competition_id, templates_visible: false, competition_type:selected?undefined:comp_type, competition_result_type:selected ? undefined: comp_result })}
            >
                <Image
                    source={{ uri: data.item.image?.url }}
                    style={{ height:30, width:30 }}
                    resizeMode='contain'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.competition_name}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.competition_description}</Text>
                </View>
            </Button>
        )
    }

    const renderResultTypes = (data:{item:CompetitionResultTypeProps, index:number}) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', borderRadius:0, padding:10, alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => setDraft({ ...draft, competition_result_type: data.item, results_visible: false })}
            >
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{data.item.label}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:10 }}>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Name</Text>
                <TextInput
                    placeholder='Add Name here...'
                    value={competition_name}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:competition_name ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setDraft({ ...draft, competition_name: text })}
                />
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Description</Text>
                <TextInput
                    placeholder='Add Decription here...'
                    value={competition_description}
                    onFocusPosition={onFocusPosition}
                    style={{ borderColor:competition_description ? Colors.text.success : Colors.text.warning }}
                    onChangeText={(text) => setDraft({ ...draft, competition_description: text })}
                />
            </View>
            {templates.length > 0 ?
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Templates</Text>
                <Button float onPress={() => setDraft({ ...draft, templates_visible: !templates_visible, competition_template_id:undefined })}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{template?.competition_name ?? 'Select Template'}</Text>
                        <Icons.ChevronIcon direction={templates_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {templates_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={templates.sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())}
                        key={'templates_list'}
                        keyExtractor={item => item.competition_id.toString()}
                        renderItem={renderTemplates}
                    />
                    </View>
                    :<></>}
                </Button>
            </View>
            :<></>}
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Competition Type</Text>
                <Button float style={{ borderColor:competition_type ? Colors.text.success: Colors.text.warning }} onPress={() => setDraft({ ...draft, types_visible: !types_visible })}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{competition_type?.type_label ?? 'Select Type'}</Text>
                        <Icons.ChevronIcon direction={types_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {types_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={competition_types.sort((a,b) => a.type_label.localeCompare(b.type_label))}
                        key={'competition_types'}
                        keyExtractor={item => item.competition_type_id.toString()}
                        renderItem={renderCompetitionTypes}
                    />
                    </View>
                    :<></>}
                </Button>
            </View>
            <View style={{ padding:10 }}>
                <Text theme='h1' style={{ marginBottom:10 }}>Payout Type</Text>
                <Button float style={{ borderColor:competition_result_type ? Colors.text.success: Colors.text.warning }} onPress={() => setDraft({ ...draft, results_visible: !results_visible })}>
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ flex:1, marginRight:10 }} theme='h1'>{competition_result_type?.label ?? 'Select Payout'}</Text>
                        <Icons.ChevronIcon direction={results_visible?'up':'down'} color={Colors.text.h1} size={8} />
                    </View>
                    {results_visible ?
                    <View transparent style={{ marginTop:20 }}>
                    <FlatList
                        data={competition_result_types.sort((a,b) => a.label.localeCompare(b.label))}
                        key={'competition_reult_types'}
                        keyExtractor={item => item.competition_result_type_id.toString()}
                        renderItem={renderResultTypes}
                    />
                    </View>
                    :<></>}
                </Button>
            </View>
        </View>
    )
}